import { Controller } from "@hotwired/stimulus"
import { createSubmitLock } from "../submit_lock.mjs"

// Guards a plain (non-Turbo-remote) form against a double-click or a
// double Enter-press submitting it twice. Rails still renders
// data-disable-with on the submit control by default, but that attribute is
// only ever interpreted by rails-ujs — this app ships Turbo instead, so
// nothing reads it, and a `local: true` form has no other protection: two
// submit events fired close enough together (a real fast double-click) can
// both reach the server before either one's response — let alone a
// disabled-button visual — comes back.
//
// The actual lock is a plain, non-Stimulus object (submit_lock.mjs) so its
// one-shot behavior can be unit tested directly; this class only wires it
// to the DOM.
export default class extends Controller {
  connect() {
    this.submitLock = createSubmitLock()
  }

  lock(event) {
    const proceeding = this.submitLock.lock(() => this.disableSubmitControls())
    if (!proceeding) event.preventDefault()
  }

  disableSubmitControls() {
    this.element.querySelectorAll('input[type="submit"], button[type="submit"]').forEach(control => {
      control.disabled = true
      const disableWith = control.dataset.disableWith
      if (!disableWith) return

      if (control.tagName === "INPUT") control.value = disableWith
      else control.textContent = disableWith
    })
  }
}
